import * as TYPES from './types';
import { setKeysToFalseExceptKey } from './utils/index';
export default {
  [TYPES.SET_ACCORDION_ITEM](state, val) {
    state.productAccordionItems[val] = !state.productAccordionItems[val];
    state.productAccordionItems = setKeysToFalseExceptKey(state.productAccordionItems, val);
  },
  [TYPES.SHOW_ACCORDION_ITEM](state, val) {
    state.productAccordionItems[val] = true;
    state.productAccordionItems = setKeysToFalseExceptKey(state.productAccordionItems, val);
  },
  [TYPES.SET_ACCORDION_DESCRIPTION](state, isMobile) {
    if (isMobile) {
      state.productAccordionItems.description = false;
    } else {
      state.productAccordionItems.description = true;
    }
  }
};